<template>
  <div>仪器预约</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
